import type { ReactNode } from 'react';
import { Typography, theme } from 'antd';

export const orDash = (value: ReactNode): ReactNode =>
  value === null || value === undefined || value === '' ? (
    <Typography.Text type="secondary">—</Typography.Text>
  ) : (
    value
  );

/**
 * Vertical, borderless Descriptions with a small secondary label.
 * The label colour is left to antd's own `Descriptions` styling so it
 * follows the active theme; a hook so the label size tracks the theme
 * too.
 */
export const useVerticalDescProps = () => {
  const { token } = theme.useToken();
  return {
    layout: 'vertical',
    colon: false,
    size: 'small',
    styles: {
      label: {
        fontSize: token.fontSizeSM,
        paddingBottom: 0,
      },
    },
  } as const;
};

/** Strips the `Show` wrapper so each tab body owns its own Card. */
export const bareShowContentProps = {
  style: {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  styles: { body: { padding: 0 } },
} as const;
